// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"kp-z","slideIn":"lp-z"};